module.exports = __webpack_public_path__ + "static/ACRC_Headshots_Final-bd3b2c8192a645ba2d8438c054a26baf.gif";